import { render, staticRenderFns } from "./FormattedNumberField.vue?vue&type=template&id=57b984ae&scoped=true"
import script from "./FormattedNumberField.vue?vue&type=script&lang=js"
export * from "./FormattedNumberField.vue?vue&type=script&lang=js"
import style0 from "./FormattedNumberField.vue?vue&type=style&index=0&id=57b984ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b984ae",
  null
  
)

export default component.exports